
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

interface AddressSectionProps {
  addressLine1: string;
  addressLine2: string;
  addressLine3: string;
  postalCode: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

const AddressSection = ({ 
  addressLine1, 
  addressLine2, 
  addressLine3, 
  postalCode, 
  onChange 
}: AddressSectionProps) => {
  return (
    <>
      <div className="space-y-2">
        <Label htmlFor="addressLine1">Company Address Line 1 *</Label>
        <Input 
          id="addressLine1" 
          name="addressLine1" 
          value={addressLine1} 
          onChange={onChange} 
          required 
        />
      </div>
      
      <div className="space-y-2">
        <Label htmlFor="addressLine2">Company Address Line 2</Label>
        <Input 
          id="addressLine2" 
          name="addressLine2" 
          value={addressLine2} 
          onChange={onChange} 
        />
      </div>
      
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <div className="space-y-2">
          <Label htmlFor="addressLine3">Company Address Line 3</Label>
          <Input 
            id="addressLine3" 
            name="addressLine3" 
            value={addressLine3} 
            onChange={onChange} 
          />
        </div>
        <div className="space-y-2">
          <Label htmlFor="postalCode">Postal Code *</Label>
          <Input 
            id="postalCode" 
            name="postalCode" 
            value={postalCode} 
            onChange={onChange} 
            required 
          />
        </div>
      </div>
    </>
  );
};

export default AddressSection;
